import axios from 'axios'
import { useState } from 'react'

export const instance = axios.create({
  baseURL: wbConfig.baseUrl,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
})

export function useCategories() {
  const [categories, setCategories] = useState([])
  const fetchCategories = async () => {
    const response = await instance({
      method: 'get',
      url: 'adminActivity/orgConfiguration',
      params: {
        json: true,
      },
    })

    setCategories(() => [...response.data.data.goalCategoryList])
  }

  return [categories, fetchCategories]
}
